import { gql } from '@apollo/client';
import USER_FRAGMENT from './userFragment.graphql';

const GET_GROUPS_QUERY = gql`
  query GetGroups($query: String, $first: Int, $after: String) {
    viewer {
      __typename
      id
      company {
        __typename
        id
        groups(query: $query, first: $first, after: $after) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            __typename
            id
            name
            databaseId
            viewerFavorited
            users {
              nodes {
                ...ProjectUserFragment
              }
            }
          }
        }
      }
    }
  }
  ${USER_FRAGMENT}
`;

export default GET_GROUPS_QUERY;
